__turbopack_context__.v({
  "cardOverlay": "eventCard-module__8p9fJq__cardOverlay",
  "categoryPill": "eventCard-module__8p9fJq__categoryPill",
  "dateTag": "eventCard-module__8p9fJq__dateTag",
  "eventCard": "eventCard-module__8p9fJq__eventCard",
  "exploreText": "eventCard-module__8p9fJq__exploreText",
  "hoverDescription": "eventCard-module__8p9fJq__hoverDescription",
  "hoverFooter": "eventCard-module__8p9fJq__hoverFooter",
  "hoverInfo": "eventCard-module__8p9fJq__hoverInfo",
  "poster": "eventCard-module__8p9fJq__poster",
  "posterWrapper": "eventCard-module__8p9fJq__posterWrapper",
});
